import { useState } from 'react';
import { faqList, siteMeta } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqList[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="scroll-mt-24 w-full bg-secondary-50 border-y border-secondary-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-label whitespace-nowrap">
                <i className="ri-question-answer-line" aria-hidden="true" />
                被问得最多
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold leading-snug text-foreground-950">
                常见问题，一次说清
              </h2>
              <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
                关于最新入口、防走丢、地址更新节奏的疑问，基本都能在这里找到答案。找不到的，也可以回头再看一遍上方的使用指南。
              </p>

              <div className="mt-6 rounded-lg bg-background-50 border border-secondary-300 p-5">
                <div className="flex items-center gap-2.5">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className="ri-customer-service-2-line" aria-hidden="true" />
                  </span>
                  <p className="font-heading text-base font-bold text-foreground-950">仍然没有答案？</p>
                </div>
                <p className="mt-3 text-[13px] leading-relaxed text-foreground-700">
                  先确认站点名称「{siteMeta.name}」，再从书签回到本页查看最新状态。多数访问异常会在下一轮校验后自动恢复。
                </p>
                <a
                  href="#entrances"
                  className="mt-4 inline-flex items-center gap-2 text-sm font-label text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
                >
                  回到入口列表
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
            </div>
          </aside>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqList.map((item, index) => {
                const isOpen = openId === item.id;
                return (
                  <li
                    key={item.id}
                    className={`rounded-lg border bg-background-50 overflow-hidden transition-colors duration-300 animate-fade-up ${
                      isOpen ? 'border-primary-300' : 'border-secondary-200'
                    }`}
                    style={{ animationDelay: `${index * 70}ms` }}
                  >
                    <button
                      type="button"
                      onClick={() => toggle(item.id)}
                      aria-expanded={isOpen}
                      className="w-full flex items-start justify-between gap-4 px-5 py-5 text-left cursor-pointer"
                    >
                      <span className="flex items-start gap-3">
                        <span
                          className={`font-heading text-sm font-bold mt-0.5 shrink-0 ${
                            isOpen ? 'text-primary-600' : 'text-foreground-400'
                          }`}
                        >
                          {String(index + 1).padStart(2, '0')}
                        </span>
                        <span className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950">
                          {item.question}
                        </span>
                      </span>
                      <span
                        className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full transition-colors duration-300 ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true" />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-[60px] animate-fade-in">
                        <p className="text-sm leading-relaxed text-foreground-700">{item.answer}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}